/* Rod Armour — Aggregate rating into JSON-LD product schema (Opus 4.7 12-May)
   Watches the Yotpo summary widget on PDP. When it loads, injects
   aggregateRating into the existing data-ra-product-schema JSON.
   Extracted from inline <script> in snippets/product-template.liquid.
   productUrl is read from the existing schema (no Liquid injection needed). */
(function () {
  function init() {
    function parseNumber(text) {
      if (!text) return null;
      var match = String(text).replace(/,/g, '').match(/-?\d+(?:\.\d+)?/);
      return match ? Number(match[0]) : null;
    }

    function syncAggregateRatingSchema() {
      var summary = document.querySelector('[data-ra-review-summary][data-ra-average-score][data-ra-total-reviews]');
      if (!summary) return false;

      var ratingValue = parseNumber(summary.getAttribute('data-ra-average-score'));
      var reviewCount = parseNumber(summary.getAttribute('data-ra-total-reviews'));
      if (!ratingValue || !reviewCount) return false;

      var prior = document.querySelector('script[data-ra-aggregate-rating]');
      if (prior) prior.remove();

      var productSchemaScript = document.querySelector('script[data-ra-product-schema]');
      if (!productSchemaScript) return false;

      var schema;
      try {
        schema = JSON.parse(productSchemaScript.textContent);
      } catch (error) {
        return false;
      }
      if (!schema || schema['@type'] !== 'Product') return false;

      var productUrl = schema['@id'] || schema.url;
      schema['@id'] = schema['@id'] || productUrl;
      schema.url = schema.url || productUrl;
      schema.aggregateRating = {
        '@type': 'AggregateRating',
        'ratingValue': ratingValue,
        'bestRating': 5,
        'worstRating': 1,
        'reviewCount': reviewCount
      };

      productSchemaScript.textContent = JSON.stringify(schema);
      return true;
    }

    if (syncAggregateRatingSchema()) return;

    var observer = new MutationObserver(function () {
      if (syncAggregateRatingSchema()) observer.disconnect();
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-ra-average-score', 'data-ra-total-reviews']
    });
    window.setTimeout(function () { observer.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
